module.exports = __webpack_public_path__ + "static/media/live-monitor-blue.52cc455d.svg";